import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=1bd8b3b7&scoped=true"
import script from "./tag.vue?vue&type=script&lang=js"
export * from "./tag.vue?vue&type=script&lang=js"
import style0 from "./tag.vue?vue&type=style&index=0&id=1bd8b3b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd8b3b7",
  null
  
)

export default component.exports